<template>
    <div>
        <dashboard-layout>
            <v-container fluid class="down-top-padding py-0">
                <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
                <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                    <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                        <update-profile-information-form :user="$page.props.user" />
                        <jet-section-border />
                    </div>

                    <div v-if="$page.props.jetstream.canUpdatePassword && ($page.props.user.usertype !== 'operators')">
                        <update-password-form class="mt-10 sm:mt-0" />
                        <jet-section-border />
                    </div>

                    <!-- <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                        <two-factor-authentication-form class="mt-10 sm:mt-0" />
                        <jet-section-border />
                    </div> -->

                    <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />

                    <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                        <jet-section-border />
                        <delete-user-form class="mt-10 sm:mt-0" />
                    </template>
                </div>
            </v-container>
        </dashboard-layout>
    </div>
</template>

<script>
import DeleteUserForm from './DeleteUserForm'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import UpdateProfileInformationForm from './UpdateProfileInformationForm'
import DashboardLayout from '../../Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default {
    props: ['sessions'],

    components: {
        DashboardLayout,
        BaseBreadcrumb,
        DeleteUserForm,
        JetSectionBorder,
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },

    data() {
        return {
            page: {
                title: "Settings",
            },
            breadcrumbs: [
                {
                    text: "Dashboard",
                    disabled: false,
                    to: "/dashboard",
                },
                {
                    text: "Settings",
                    disabled: true,
                },
            ],
        }
    },

    mounted: function() {

    }
}
</script>
